import React, { useState } from "react";
import { Col, Row, Spin, Form, Select, Button } from "antd";
import { FONT } from "constants/index";
import { notificationErroInternal } from "util/api-utils";

const areas = [
  { label: "PISCINA MOVIMENTO", value: "PISCINA MOVIMENTO" },
  { label: "PISCINA PERFORMANCE", value: "PISCINA PERFORMANCE" },
];

const levels = [
  { label: "APERFEIÇOAMENTO", value: "APERFEIÇOAMENTO" },
  { label: "AVENTUREIROS", value: "AVENTUREIROS" },
  { label: "BEBÊ ÁGUA", value: "BEBÊ ÁGUA" },
  { label: "CONDICIONAMENTO", value: "CONDICIONAMENTO" },
  { label: "CONQUISTADORES", value: "CONQUISTADORES" },
  { label: "DESCOBRIDORES", value: "DESCOBRIDORES" },
  { label: "EXPLORADORES", value: "EXPLORADORES" },
  { label: "HIDROGINÁSTICA", value: "HIDROGINÁSTICA" },
  { label: "INICIAÇÃO", value: "INICIAÇÃO" },
  { label: "NAVEGADORES", value: "NAVEGADORES" },
  { label: "RAIA LIVRE", value: "RAIA LIVRE" },
];

const ManageralAguaFilter = ({ findData }) => {
  const [area, setArea] = useState([]);
  const [level, setLevel] = useState([]);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const applyFilter = async () => {
    const filter = {
      pool: area,
      level: level,
    };
    setLoading(true);
    try {
      await findData?.(filter);
    } catch (err) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <Spin spinning={loading}>
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="pool"
              label={<span style={{ fontFamily: FONT }}>Piscina</span>}
            >
              <Select
                showSearch
                allowClear
                mode="multiple"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.children ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
                options={areas}
                placeholder="Selecionar..."
                onChange={setArea}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="level"
              label={<span style={{ fontFamily: FONT }}>Nível</span>}
            >
              <Select
                showSearch
                mode="multiple"
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.children ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
                options={levels}
                onChange={setLevel}
                placeholder="Selecionar..."
              />
            </Form.Item>
            <Form.Item>
              <Row justify={"end"}>
                <Button
                  style={{ fontFamily: FONT }}
                  onClick={applyFilter}
                  type="primary"
                >
                  Aplicar
                </Button>
              </Row>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default ManageralAguaFilter;
